import { ICONS, PFE_ICONS } from 'constants/icons';

import messages from './HowSmartRateWorks.messages';

export const TOPIC_IDS = Object.freeze({
  GUARANTEED_MINIMUM: 'guaranteed-minimum',
  ADJUSTS_CREDITS: 'adjusts-credits',
  MAXIMIZES_REVENUE: 'maximizes-revenue',
});

export const makeTabId = topicId => `smart-rate-tab-${topicId}`;
export const makePanelId = topicId => `smart-rate-panel-${topicId}`;

export const TOPIC_SEGMENT_NAME = Object.freeze({
  [TOPIC_IDS.GUARANTEED_MINIMUM]: 'Guaranteed minimum',
  [TOPIC_IDS.ADJUSTS_CREDITS]: 'Adjusts credits',
  [TOPIC_IDS.MAXIMIZES_REVENUE]: 'Maximizes revenue',
});

export const TOPIC_PANEL_TRANSITION_MS = 300;

export const TOPICS = [
  {
    id: TOPIC_IDS.GUARANTEED_MINIMUM,
    icon: PFE_ICONS.earningPotential,
    title: messages.guaranteedMinimumTitle,
    description: messages.guaranteedMinimumDescription,
  },
  {
    id: TOPIC_IDS.ADJUSTS_CREDITS,
    icon: ICONS.settingsSliders,
    title: messages.adjustsCreditsTitle,
    description: messages.adjustsCreditsDescription,
  },
  {
    id: TOPIC_IDS.MAXIMIZES_REVENUE,
    icon: ICONS.marketingGraph,
    title: messages.maximizesRevenueTitle,
    description: messages.maximizesRevenueDescription,
  },
];

export const getTopicById = topicId => TOPICS.find(topic => topic.id === topicId);
